import { z } from "zod/v4-mini";

import { CGMDexcomDataEvent } from "@/lib/drivers/tandem/events/LID_CGM_DATA_G7";
import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CGMGXDataSamplePayload = {
  status?: number;
  type?: number;
  rate?: number;
  rssi?: number;
  value?: number;
  timestamp?: number;
  transmitter_timestamp?: number;
};

const cGMGXDataSampleSchema = z.object({
  status: cz.permissive(z.number()),
  type: cz.permissive(z.number()),
  rate: cz.permissive(z.number()),
  rssi: cz.permissive(z.number()),
  value: cz.permissive(z.number()),
  timestamp: cz.permissive(z.number()),
  transmitter_timestamp: cz.permissive(z.number()),
});

export const LID_CGM_DATA_GX = {
  value: 0xd3,
  name: "CGM GX Data Sample",
  format: "sby.ysii",
  fields: ["status", "type", "rate", "rssi", "value", "timestamp", "transmitter_timestamp"],
  postprocess: rec => ({
    status: rec.status,
    type: rec.type,
    rate: rec.rate,
    rssi: rec.rssi,
    value: rec.value,
    timestamp: rec.timestamp,
    transmitterTimestamp: rec.transmitter_timestamp,
  }),
  schema: cGMGXDataSampleSchema,
} as const satisfies TandemEventDefinition<CGMGXDataSamplePayload, CGMDexcomDataEvent>;
